import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading|not-known, false=guest, object=user
  const [ready, setReady] = useState(false);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("hyd_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("hyd_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const requestOtp = async (phone) => {
    try {
      const { data } = await api.post("/auth/request-otp", { phone });
      return data;
    } catch (e) {
      throw new Error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  const verifyOtp = async (phone, otp, name) => {
    try {
      const { data } = await api.post("/auth/verify-otp", { phone, otp, name });
      localStorage.setItem("hyd_token", data.token);
      setUser(data.user);
      return data.user;
    } catch (e) {
      throw new Error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  const verifyAdminPin = async (phone, pin) => {
    try {
      const { data } = await api.post("/auth/admin-login", { phone, pin });
      localStorage.setItem("hyd_token", data.token);
      setUser(data.user);
      return data.user;
    } catch (e) {
      throw new Error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  const logout = () => {
    localStorage.removeItem("hyd_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, requestOtp, verifyOtp, verifyAdminPin, logout, refresh: bootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
